import React from "react";
import { FINANCE_CALCULATOR } from "../../../../../../common-deprecated/constants";
import { BnbLabel, getBnbLabel, getBnbOptionalLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { useBnbSelector } from "../../../redux/store";
import FinanceInsuranceCalculatorLink from "../../../utils/FinanceInsuranceCalculatorLink";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import Price from "../common/price/Price";
import PriceFootNote from "../common/price/PriceFootNote";
import * as Styles from "./styles/SummaryTotalPanel";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import ButtonSecondary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { getBnbPriceConfig } from "../../../utils/settings/bnbFinanceSettingUtils";
import { NavStep } from "../../../../shared-logic/utils/Navigation";

const SummaryTotalPanel = (): JSX.Element | null => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const total = useBnbSelector((state) => state.basket.total);
    const modelCode = useBnbSelector((state) => state.car?.model?.internalCode);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const isRtl = useBnbSelector((state) => isRTL(state.commonSettings));
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const showPriceSettings = showPrice(commonSettings);
    const aemPriceConfig = getBnbPriceConfig(commonSettings, modelCode, NavStep.Summary);

    if (!showPriceSettings || !aemPriceConfig.priceEnabled) return null;

    // show title when there is a label for it
    const showTitle =
        !!getBnbOptionalLabel({ commonSettings, bnbSettings }, "financeOptionTotalCash") ||
        !!getBnbOptionalLabel({ commonSettings, bnbSettings }, "financeOptionTotalMonthly") ||
        (financeOption === "monthly" && financeInfo.productName);

    const totalLabel = financeOption === "monthly" ? "financeOptionTotalMonthly" : "financeOptionTotalCash";

    return (
        <Styles.Wrapper>
            <Styles.HeaderTitle>
                <Type.H5 color="midnight">
                    <BnbLabel label="total" />
                </Type.H5>
            </Styles.HeaderTitle>

            <Styles.Panel>
                <Styles.Header>
                    <Flex.Row>
                        <Flex.Col width={1 / 2}>
                            {showTitle && (
                                <Type.H5 color="midnight">
                                    {financeOption === "monthly" && financeInfo.productName ? (
                                        financeInfo.productName
                                    ) : (
                                        <BnbLabel label={totalLabel} />
                                    )}
                                </Type.H5>
                            )}
                        </Flex.Col>
                        <Flex.Col
                            width={1 / 2}
                            display="flex"
                            flexDirection="column"
                            alignItems="flex-end"
                            justifyContent="flex-end"
                            textAlign={isRtl ? "left" : "right"}
                        >
                            <Styles.PriceWrapper>
                                <Type.H5 color="midnight">
                                    <Price price={total} financeItemId="total" forceMonthlyDisclaimer showLoader />
                                </Type.H5>
                                <PriceFootNote />
                            </Styles.PriceWrapper>
                        </Flex.Col>
                    </Flex.Row>
                    {!bnbSettings?.showFinanceInsuranceInPage &&
                        !bnbSettings?.enableFinanceCompare &&
                        financeOption === "monthly" && (
                            <Flex.Row width="100%">
                                <Flex.Col display="flex" flex={1} justifyContent="flex-end">
                                    <FinanceInsuranceCalculatorLink
                                        type={FINANCE_CALCULATOR}
                                        customButton={(props) => (
                                            <ButtonSecondary onClick={() => props.onClick()}>
                                                {getBnbLabel({ commonSettings, bnbSettings }, props.label)}
                                            </ButtonSecondary>
                                        )}
                                    />
                                </Flex.Col>
                            </Flex.Row>
                        )}
                </Styles.Header>
            </Styles.Panel>
        </Styles.Wrapper>
    );
};

export default SummaryTotalPanel;
